import React, {useState} from "react";
import auth from "../../../utils/authentication";
import {Link, useNavigate} from "react-router-dom";
import {FormattedMessage, useIntl} from "react-intl";
import GoogleLogin from "../googleLogin/googleLogin";
import {goHomeAfterLogin, isMobileDevice} from "../../../utils/utils";

function Login({setCurrentPage, onFinishLogin}) {

    const intl = useIntl();

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showDisableButton, setShowDisableButton] = useState(false);

    const enableUser = (e) => {
        e.preventDefault();
        dismissError();
    }

    const loginUser = (e) => {
        e.preventDefault();
        dismissError();
        auth.signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                onFinishLogin();
                if (goHomeAfterLogin()) {
                    navigate('/home');
                }
            })
            .catch((error) => {
                // Handle any errors that occur during sign in
                document.querySelectorAll('input').forEach(x => x.classList.add('is-invalid'))
                if (error.message.includes('auth/user-not-found')) {
                    setError(intl.formatMessage({id: "users.login.bad-email"}));
                } else if (error.message.includes('auth/user-disabled')) {
                    setError(intl.formatMessage({id: "users.login.error-disabled"}));
                    setShowDisableButton(true);
                } else if (error.message.includes('auth/wrong-password')) {
                    setError(intl.formatMessage({id: "users.login.bad-password"}));
                }
                // Handle the error accordingly
            });
    }

    function dismissError() {
        setError("");
        document.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = isMobileDevice() ? "col-10" : "col-7";

    return (
        <div className="col-12">
            <div className="col-12 text-center">
                <GoogleLogin onFinishLogin={onFinishLogin}/>
            </div>
            <div className="d-flex flex-row align-items-center col-12 justify-content-center">
                <hr className="col-4 me-3"/>
                <span className="text-center"><FormattedMessage id="users.login.or"/></span>
                <hr className="col-4 ms-3"/>
            </div>
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center">
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}

                <div className={"form-floating mb-3 " + colSize}>
                    <input value={email} onChange={e => {
                        setEmail(e.target.value);
                        setShowDisableButton(false);
                    }}
                           type="email" className="form-control" id="floatingInput" placeholder="Correo electrónico"/>
                    <label htmlFor="floatingInput"><FormattedMessage id="users.input.email"/></label>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input value={password} onChange={e => setPassword(e.target.value)}
                           type="password" className="form-control" id="floatingPassword" placeholder="Contraseña"/>
                    <label htmlFor="floatingPassword"><FormattedMessage id="users.input.password"/></label>
                </div>
                <div className={colSize + " mb-3 d-flex flex-row justify-content-between"}>
                    {!showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        loginUser(e);
                    }}><FormattedMessage id="users.login.log-in"/></button>}
                    {showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        enableUser(e);
                    }}><FormattedMessage id="users.login.enable-user"/></button>}
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}
                       onClick={() => setCurrentPage("recoverPass")}><FormattedMessage
                        id="users.login.forgot-password"/></a>
                </div>
                <div className={colSize + " mb-3"}>
                    <b><FormattedMessage id="users.login.dont-have-account"/></b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}
                       onClick={() => setCurrentPage("signUp")}><FormattedMessage id="users.login.sign-up"/></a>
                </div>
            </form>
        </div>
    )
}

export default Login;
